import * as React from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import {connect} from "react-redux";
import authState from '../../ReduxRequests/State/authState';
import errorCodeDispatch from '../../ReduxRequests/Dispatch/errorCodeDispatch';
import {URL} from '../../Config/appConfig';
import {Auth, CoverNote, RecordCount, ErrorCodeLang} from '../../Config/dataModel';
import PrivateRoute from './PrivateRoute';
import Login from '../Auth/Login';
import ForgotPassword from '../Auth/ForgotPassword';
import SetPassword from '../Auth/SetPassword';
import ResetPassword from '../Auth/ResetPassword';
import DashboardContainer from '../Containers/DashboardContainer';
import CreateContainer from '../Containers/CreateContainer';
import CoverNoteContainer from '../Containers/CoverNoteContainer';
import ViewCoverNoteContainer from '../Containers/ViewCoverNoteContainer';
import PolicyContainer from '../Containers/PolicyContainer';
import ViewPolicyContainer from '../Containers/ViewPolicyContainer';
import ArchivedContainer from '../Containers/ArchivedContainer';
import ViewArchivedCoverNoteContainer from '../Containers/ViewArchivedCoverNoteContainer';
import ViewArchivedPolicyContainer from '../Containers/ViewArchivedPolicyContainer';
import BatchContainer from '../Containers/BatchContainer';
import SearchContainer from '../Containers/SearchContainer';
import SettingsContainer from '../Containers/SettingsContainer';
import Enquiry from '../Enquiry/Enquiry';
import CompaniesContainer from '../Containers/CompaniesContainer';
import NormalUsersContainer from '../Containers/NormalUsersContainer';
import ApiUsersContainer from '../Containers/ApiUsersContainer';
import Secret from '../Secret/Secret';
import NotFound from '../NotFound/NotFound';
import {STATES} from '../../Config/websocketConfig';
import {subscribe} from "../../Websocket/websocket";
import { getLanguage } from 'src/Util/language';

interface RouterProps {
    fetchErrorCode: (lang: ErrorCodeLang) => void,
    auth: () => Auth,
    loginState: () => boolean
}

interface RouterState {
    newRecord: CoverNote,
    newCount: RecordCount
}

class Router extends React.Component <RouterProps, RouterState> {
    public constructor(props: RouterProps) {
        super(props);
        this.state = {
            newRecord: null,
            newCount: null
        };
    }

    public componentDidMount() {
        const lang = getLanguage();
        this.props.fetchErrorCode({lang: lang.toUpperCase()});
        this.connectWebsocker();
    }

    public componentWillReceiveProps(nextProps: RouterProps) {
        if (nextProps.loginState() !== this.props.loginState() && nextProps.loginState()) this.connectWebsocker();
    }

    public connectWebsocker() {
        if (this.props.auth() && this.props.auth().insurer) {
            let subscriptions = [];
            STATES.forEach(state => {
                subscriptions.push({
                    path: state.path,
                    callback: res => {
                        const updateState = {};
                        updateState[state.stateToBeUpdated] = JSON.parse(res.body);
                        this.setState(updateState);
                    }
                });
            });
            subscribe(subscriptions);
        }
    }

    public render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact={true} path={`(${URL.LOGIN}|${URL.SESSION_EXPIRED}|${URL.UNSUBSCRIBE})`} component={Login}/>
                    <Route exact={true} path={URL.ENQUIRY} component={Enquiry}/>
                    <PrivateRoute exact={true} path={URL.FORGOT_PASSWORD} needsAuth={false} component={ForgotPassword}/>
                    <PrivateRoute exact={true} path={URL.SET_PASSWORD} needsAuth={false} component={SetPassword}/>
                    <PrivateRoute exact={true} path={URL.RESET_PASSWORD} needsAuth={false} component={ResetPassword}/>
                    <PrivateRoute exact={true} path={URL.DASHBOARD} needsAuth={true} component={DashboardContainer} newCount={this.state.newCount}/>
                    <PrivateRoute exact={true} path={URL.CREATE} needsAuth={true} component={CreateContainer}/>
                    <PrivateRoute exact={true} path={URL.COVER_NOTE} needsAuth={true} component={CoverNoteContainer} newRecord={this.state.newRecord} newCount={this.state.newCount}/>
                    <PrivateRoute exact={true} path={URL.VIEW_COVER_NOTE} needsAuth={true} component={ViewCoverNoteContainer}/>
                    <PrivateRoute exact={true} path={URL.POLICY} needsAuth={true} component={PolicyContainer} newRecord={this.state.newRecord} newCount={this.state.newCount}/>
                    <PrivateRoute exact={true} path={URL.VIEW_POLICY} needsAuth={true} component={ViewPolicyContainer}/>
                    <PrivateRoute exact={true} path={URL.ARCHIVED} needsAuth={true} component={ArchivedContainer} newRecord={this.state.newRecord} newCount={this.state.newCount}/>
                    <PrivateRoute exact={true} path={URL.VIEW_ARCHIVED_COVER_NOTE} needsAuth={true} component={ViewArchivedCoverNoteContainer}/>
                    <PrivateRoute exact={true} path={URL.VIEW_ARCHIVED_POLICY} needsAuth={true} component={ViewArchivedPolicyContainer}/>
                    <PrivateRoute exact={true} path={URL.BATCH} needsAuth={true} component={BatchContainer}/>
                    <PrivateRoute exact={true} path={URL.SEARCH} needsAuth={true} component={SearchContainer}/>
                    <PrivateRoute exact={true} path={URL.SETTINGS} needsAuth={true} component={SettingsContainer}/>
                    <PrivateRoute exact={true} path={URL.COMPANIES} needsAuth={true} component={CompaniesContainer}/>
                    <PrivateRoute exact={true} path={URL.NORMAL_USERS} needsAuth={true} component={NormalUsersContainer}/>
                    <PrivateRoute exact={true} path={URL.API_USERS} needsAuth={true} component={ApiUsersContainer}/>
                    <Route exact={true} path={URL.SECRET} component={Secret}/>
                    <Route component={NotFound}/>
                </Switch>
            </BrowserRouter>
        );
    }
}

export default connect(authState, errorCodeDispatch)(Router);



// WEBPACK FOOTER //
// ./src/Components/Router/Router.tsx